export const genericComponentTypes = Object.freeze({
  TEXT: 'Text',
  NUMBER: 'Number',
  DATE: 'Date',
});

export type GenericComponent = 'Text' | 'Number' | 'Date';
